module.exports = __webpack_public_path__ + "static/SFCompactHeavy-92fa62ba0b971a84296e442db342cb40.woff2";